import { render, staticRenderFns } from "./PriceOption.vue?vue&type=template&id=0d0e0675&"
import script from "./PriceOption.vue?vue&type=script&lang=js&"
export * from "./PriceOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports